import React from 'react';
import CheckBox from './CheckBox';

export interface CheckBoxOption {
  id: string;
  label: React.ReactNode;
  value?: string;
}

interface CheckBoxGroupProps {
  options: CheckBoxOption[];
  title?: React.ReactNode;
  name?: string;
}

const CheckBoxGroup: React.FC<CheckBoxGroupProps> = ({
  options,
  title,
  name,
}) => (
  <div className={`flex items-start`}>
    {title && (
      <div className="mb-0 mr-4 text-left checkbox-group-title whitespace-nowrap">{title}</div>
    )}
    <div className="flex flex-col items-start">
      {options.map(option => (
        <CheckBox
          key={option.id}
          id={option.id}
          name={name}
          value={option.value}
        >
          {option.label}
        </CheckBox>
      ))}
    </div>
  </div>
);

export default CheckBoxGroup;
